import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { NAV, PHONE, PHONE_TEL, EMAIL, LOCATION, HOURS, SERVICES } from "../lib/data";

export default function Footer() {
  return (
    <footer className="relative bg-ink border-t border-white/[0.06] pt-20 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <Logo className="h-20" />
            <p className="mt-6 text-white/55 text-sm leading-relaxed max-w-xs">
              Ihr Spezialist für Elektrovorbereitung und Kernbohrungen. Präzise, staubarm und
              termingerecht – in geprüfter deutscher Qualität.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-lg mb-5">Navigation</h4>
            <ul className="flex flex-col gap-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} data-scroll={n.href} data-testid={`footer-nav-${n.label}`} className="text-white/55 hover:text-volt transition-colors text-sm">{n.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-lg mb-5">Leistungen</h4>
            <ul className="flex flex-col gap-3">
              {SERVICES.map((s) => (
                <li key={s.title} className="text-white/55 text-sm">{s.title}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-lg mb-5">Kontakt & Öffnungszeiten</h4>
            <ul className="flex flex-col gap-3 text-sm">
              <li><a href={`tel:${PHONE_TEL}`} className="flex items-center gap-3 text-white/70 hover:text-volt transition-colors"><Phone className="h-4 w-4 text-volt shrink-0" />{PHONE}</a></li>
              <li><a href={`mailto:${EMAIL}`} className="flex items-center gap-3 text-white/70 hover:text-volt transition-colors"><Mail className="h-4 w-4 text-volt shrink-0" />{EMAIL}</a></li>
              <li className="flex items-center gap-3 text-white/70"><MapPin className="h-4 w-4 text-volt shrink-0" />{LOCATION}</li>
            </ul>
            <div className="mt-5 pt-5 border-t border-white/[0.06] flex flex-col gap-2">
              {HOURS.map((h) => (
                <div key={h.day} className="flex items-center justify-between text-sm">
                  <span className="flex items-center gap-2 text-white/55"><Clock className="h-3.5 w-3.5 text-volt" />{h.day}</span>
                  <span className="text-white/80 font-semibold">{h.time}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <span>© {new Date().getFullYear()} VoltCore Elektro. Alle Rechte vorbehalten.</span>
          <span className="flex gap-6"><Link to="/impressum" data-testid="footer-impressum" className="hover:text-volt transition-colors">Impressum</Link><Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-volt transition-colors">Datenschutz</Link></span>
        </div>
      </div>
    </footer>
  );
}
